import { render, staticRenderFns } from "./CompanyEditResubmission.vue?vue&type=template&id=2cf13c30&"
import script from "./CompanyEditResubmission.vue?vue&type=script&lang=js&"
export * from "./CompanyEditResubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports